module.exports = __webpack_public_path__ + "img/loading.4b01ca5.gif";